export class CellHtmlRenderer{
    constructor(props) {
        const el = document.createElement('span');
        el.innerHTML = props.value || '';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

export class HeaderHtmlRenderer {
    constructor(props) {
        let header = props.columnInfo.header;
        const el = document.createElement('span');
        el.innerHTML = header;
        this.el = el;
    }

    getElement() {
        return this.el;
    }

    mounted() {
        // ...
    }

    render() {

    }

    beforeDestroy() {
        // ...
    }
}

export class ButtonRenderer {
    constructor(props) {
        const el = document.createElement('a');
        el.classList.add('btn_sm_white');
        const { text } = props.columnInfo.renderer.options;
        el.innerText = text;
        el.href = 'javascript:';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}



// WEBPACK FOOTER //
// ./src/skpComponents/common/GridCustomRenderer.js